import { pages, popPage, popWithAnimation } from "~/shared_states/modal";
import { routerLog } from "./logging";
import {
  closeIntercom,
  isIntercomVisible,
  setIsIntercomVisible,
} from "~/utils/third_party/intercom";

export default function attachPopStateListener() {
  routerLog("Attached pop state listener");
  window.onpopstate = popStateListener;
}

export function detachPopStateListener() {
  window.onpopstate = null;
  routerLog(`Popstate listener detached`);
}

/**
 * Posts a "close" event to potential external listeners across different platforms.
 * This function attempts to communicate with parent iframes, React Native,
 * native Android, native iOS, and Flutter WebViews.
 */
export function postCloseEventToAllExternalListeners() {
  // Used for Flutter and RN
  const closePayloadString = JSON.stringify({
    type: "action",
    action: "close",
  });

  // 1. For Flutter WebView (using a custom JavaScript channel)
  // This looks for a `FlutterHost` object on the window, which is injected
  // by `webview_flutter` when you create a JavaScriptChannel with that name.
  try {
    if (
      // @ts-ignore: `FlutterHost` is injected by Flutter's WebView controller.
      window.FlutterHost &&
      // @ts-ignore: `FlutterHost` is injected by Flutter's WebView controller.
      typeof window.FlutterHost.postMessage === "function"
    ) {
      routerLog(
        `Sending 'close' event to Flutter listener via 'FlutterHost' channel.`
      );
      // @ts-ignore
      window.FlutterHost.postMessage(closePayloadString);
    }
  } catch (e) {
    routerLog(`Sending event to Flutter failed: ${e}`);
  }

  // 2. For parent iFrame
  try {
    if (window.parent !== window) {
      routerLog(`Posting a message for parent iframe to close.`);
      window.parent.postMessage({ type: "close" }, "*");
    }
  } catch (e) {
    routerLog(`Posting message to parent iframe failed: ${e}`);
  }

  // 3. For React Native WebView
  try {
    // @ts-ignore: ReactNativeWebView is injected by the RN WebView component.
    if (window.ReactNativeWebView) {
      routerLog(`Sending event to RN listener.`);
      // @ts-ignore: ReactNativeWebView is injected by the RN WebView component.
      window.ReactNativeWebView.postMessage(closePayloadString);
    }
  } catch (e) {
    routerLog(`Sending event to RN failed: ${e}`);
  }

  // 4. For native Android WebView (using addJavascriptInterface)
  try {
    // @ts-ignore: AndroidHost is a common name for the JS interface on Android.
    if (window.AndroidHost && typeof window.AndroidHost.close === "function") {
      routerLog("Calling close on AndroidHost.");
      // @ts-ignore
      window.AndroidHost.close();
    }
  } catch (e) {
    routerLog(`Calling AndroidHost.close() failed: ${e}`);
  }

  // 5. For native iOS WebView (using WKScriptMessageHandler)
  try {
    // @ts-ignore: `webkit` is specific to iOS's WKWebView.
    if (window.webkit?.messageHandlers?.bridge?.postMessage) {
      routerLog(`Sending event to iOS listener via 'bridge' message handler.`);
      // @ts-ignore
      window.webkit.messageHandlers.bridge.postMessage("close");
    }
  } catch (e) {
    routerLog(`Sending event to iOS failed: ${e}`);
  }
}

export async function popStateListener() {
  routerLog("popStateListener called");
  routerLog(`Pages are ${pages().map((p) => p.name)}`);

  if (isIntercomVisible()) {
    setIsIntercomVisible(false);
    closeIntercom();
    return;
  }

  if (pages().length > 1) {
    popWithAnimation();
  } else {
    routerLog(`Last page`);

    postCloseEventToAllExternalListeners();
    popPage();
  }
}
